// Textos de recusa de cartao e do bloqueio apos recusas repetidas, aprovados pelo financeiro em
// 05/10/2026. O backend manda o tipo da recusa (declineReason) e a situacao do cartao
// (cardAttemptsLeft, cardBlockedUntil, cardDeclineLimit, cardDeclineWindowHours); aqui so se
// monta o texto. Limite e janela vem do backend para que mudar a configuracao la mude tambem o
// que o jogador le.
//
// Nenhum texto revela fraude ou antifraude: o codigo 190 (antifraude do PicPay) chega como
// "generic" de proposito.

const DECLINE_MESSAGES = {
  "insufficient-funds": "Pagamento não aprovado: o cartão não tem limite ou saldo suficiente para esta compra.",
  "contact-issuer": "Seu banco não autorizou esta compra. Verifique no aplicativo do banco se compras online estão liberadas, ou fale com a central do cartão, e tente de novo.",
  "check-card-data": "Pagamento não aprovado. Confira o número, a validade e o código de segurança do cartão.",
  "card-not-allowed": "Este cartão não pode ser usado nesta compra. Use outro cartão ou outra forma de pagamento.",
  generic: "Pagamento não aprovado. Tente outro cartão ou outra forma de pagamento.",
};

const USE_ANOTHER_CARD = "Use outro cartão ou outra forma de pagamento.";

export function declineMessage(declineReason) {
  return DECLINE_MESSAGES[declineReason] || DECLINE_MESSAGES.generic;
}

// "06/10 às 18:15", no fuso do navegador do jogador. O backend manda em UTC.
export function formatBlockedUntil(iso) {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)} às ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

// Aviso que acompanha uma recusa. Vazio quando o backend nao mandou a situacao do cartao (bloqueio
// desligado ou cartao nao identificado). `mainMessage` evita repetir "use outro cartao" quando a
// mensagem principal ja diz isso.
export function cardDeclineNotice(data, mainMessage = "") {
  if (!data || data.cardAttemptsLeft === undefined || data.cardAttemptsLeft === null) return "";

  const limit = data.cardDeclineLimit || 3;
  const hours = data.cardDeclineWindowHours || 24;

  if (data.cardBlockedUntil) {
    const when = formatBlockedUntil(data.cardBlockedUntil);
    const tail = mainMessage.includes("outro cartão") ? "" : ` ${USE_ANOTHER_CARD}`;
    return `Este cartão foi bloqueado nesta conta até ${when}.${tail}`;
  }

  const left = data.cardAttemptsLeft;
  if (left === 1) {
    return `Atenção: você pode tentar mais 1 vez com este cartão. Se for recusado de novo, ele ficará bloqueado nesta conta por até ${hours} horas.`;
  }
  if (left > 1) {
    return `Atenção: depois de ${limit} recusas em ${hours} horas, este cartão fica bloqueado temporariamente nesta conta. Você ainda pode tentar mais ${left} vezes com ele.`;
  }
  return "";
}

// Tentativa barrada antes de chegar ao PicPay, porque o cartao ja estava bloqueado.
export function blockedCardMessage(data) {
  const when = data?.cardBlockedUntil ? formatBlockedUntil(data.cardBlockedUntil) : "";
  const until = when ? ` até ${when}` : " temporariamente";
  const limit = data?.cardDeclineLimit || 3;
  const reason = data?.cardBlockReason === "repeated-declines" ? `, depois de ${limit} recusas` : "";
  return `Este cartão está bloqueado nesta conta${until}${reason}. ${USE_ANOTHER_CARD}`;
}
